import gql from 'graphql-tag';

import { UserContactRecordIntent, UserContactRecordType } from './type';
import { UserContactRecordFeedback } from './Users';

const USER_CONTACT_RECORDS_QUERY = gql`
  query GetUserContactRecords($ids: [ID]) {
    users(ids: $ids) {
      contactRecords {
        id
        createdAt
        userId
        feedback
        isSuccess
        type
        intent
        remark
        teacherName
      }
    }
  }
`;

const USER_CONTACT_RECORD_FEEDBACK_NAME = {
  // 全阶段可用

  [UserContactRecordFeedback.USER_BUSY_CONTACT_SOON]: '繁忙稍后再联系（不方便现在联系）',
  [UserContactRecordFeedback.CONTACT_NOT_SUCCESS]: '不接（一直响铃）',
  [UserContactRecordFeedback.CALL_REFUSED]: '拒接',
  [UserContactRecordFeedback.POWER_OFF]: '关机',
  [UserContactRecordFeedback.OUT_OF_SERVICE]: '停机',
  [UserContactRecordFeedback.NUMBER_NOT_EXIST]: '空号',
  [UserContactRecordFeedback.CONTACT_OTHERS]: '其他',

  // -1周加好友阶段

  [UserContactRecordFeedback.NOT_APPLIED_TRIAL_LESSON]: '没有报名体验课【不清楚情况】',
  [UserContactRecordFeedback.NO_NEED_OR_REQUIRE_REFUND_TRIAL_LESSON]: '不需要，要求退体验课',
  [UserContactRecordFeedback.REDEEM_TRIAL_LESSON_NOT_SUCCESS]: '体验课未兑换成功',
  [UserContactRecordFeedback.BOUGHT_TRIAL_LESSON_FOR_FRIEND]: '帮人购买体验课',

  // 预热期/收定金期

  [UserContactRecordFeedback.PRORDER_DONE]: '已收定金',
  [UserContactRecordFeedback.BOOK_FOR_BOOK_SUCCESS]: '绘本已登记',
  [UserContactRecordFeedback.NOT_PREORDER_BUT_POSITIVE_INTENT]: '有意向（但现在不登记/暂时不付定金）',

  // 续费年课期

  [UserContactRecordFeedback.NO_TIME_OR_CHILD_NOT_AROUND]: '不报名年课原因（没时间学习/孩子不在身边）',
  [UserContactRecordFeedback.HAS_OTHER_PRODUCT]: '不报名年课原因（已经在学习同类产品）',
  [UserContactRecordFeedback.LESSON_TOO_DIFFICULT]: ' 不报名年课原因（课程难）',
  [UserContactRecordFeedback.LESSON_TOO_EXPENSIVE]: ' 不报名年课原因（价格贵）',
  [UserContactRecordFeedback.FAMILY_DISAGREE]: '不报名年课原因（老公/老婆/家人不同意）',
  [UserContactRecordFeedback.CHILD_TAKE_BY_OLD]: '不报名年课原因（孩子老人带，没办法学习）',
  [UserContactRecordFeedback.CHILD_NOT_OLD_ENOUGH]: '不报名年课原因（孩子年纪小）',
  [UserContactRecordFeedback.WAITING_FOR_SALE]: '不报名年课原因（观望，等最后一天更大力度优惠）',
  [UserContactRecordFeedback.NOT_ENROLL_OTHERS]: '不报名年课原因（其他）',

  // 成交年课

  [UserContactRecordFeedback.ENROLL_ADVANCE_LESSON_SUCCESS]: '报名年课成功',
  [UserContactRecordFeedback.REDEEM_ADVANCE_LESSON_FAILED]: '年课未兑换成功',
};

const USER_CONTACT_RECORD_TYPE_NAME = {
  [UserContactRecordType.WECHAT]: '微信跟进',
  [UserContactRecordType.PHONE_CALL]: '电话跟进',
};

export { USER_CONTACT_RECORDS_QUERY, USER_CONTACT_RECORD_FEEDBACK_NAME, USER_CONTACT_RECORD_TYPE_NAME };



// WEBPACK FOOTER //
// ./src/screens/user/constants.ts